<div class="multi-grid">
  <ul class="multi-grid-table">
    <li class="rows bg-transparent">
      <span class="title h-auto text-left"></span>
      <span *ngFor="let rating of ratings; trackBy:trackById" class="radios text-center paragraph">
        <img *ngIf="rating.activeUrl" [src]="rating.activeUrl" alt="rating" width="24" height="24">
        <span *ngIf="rating.text">
          {{rating.text}}
        </span>
      </span>
    </li>
    <li *ngFor="let row of rows; trackBy:trackByIndex;let i = index" class="rows">
      <span class="title secondary-paragraph text-left">
        {{row?.ov}}
      </span>
      <span *ngFor="let column of columns;  trackBy:trackByIndex;let j = index" class="radios text-center">
        <label class="radio p-2">
          <input [checked]="getSelected(j, row?.code)" [name]="row?.code" type="radio" (click)="setRating(i, j)"
            [disabled]="isViewMode" />
          <span></span>
        </label>
      </span>
    </li>
  </ul>
</div>
